(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["tenders"] = factory();
	else
		root["tenders"] = factory();
})(this, function() {
return webpackJsonp_name_([6],{

/***/ 24:
/* no static exports found */
/* all exports used */
/*!*****************************!*\
  !*** ./styles/tenders.scss ***!
  \*****************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 64:
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./images/tenders-header-bg.jpg ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/tenders-header-bg.jpg";

/***/ }),

/***/ 79:
/* no static exports found */
/* all exports used */
/*!********************!*\
  !*** ./tenders.js ***!
  \********************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./images/tenders-header-bg.jpg */ 64);

__webpack_require__(/*! ./styles/tenders */ 24);

var _jquery = __webpack_require__(/*! jquery */ 0);

var _jquery2 = _interopRequireDefault(_jquery);

var _barba = __webpack_require__(/*! barba.js */ 2);

var _barba2 = _interopRequireDefault(_barba);

var _common = __webpack_require__(/*! ./common */ 1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $button = (0, _jquery2.default)('[data-load]');

function tenderOn() {
    (0, _jquery2.default)(function () {
        /**
         * Ajax more button
         */

        var isAjaxSending = false;
        var $wrapper = (0, _jquery2.default)('[data-tenders-container]');

        $button.on('click', function () {
            if (isAjaxSending) return 1;
            var $lastChild = $wrapper.find('[data-item]:last');
            var dataCount = $lastChild.data('count');
            var showValue = 5;

            _jquery2.default.ajax({
                method: 'POST',
                url: '/include/tenders_ajax.php',
                data: {
                    requested: showValue,
                    current: dataCount
                },
                complete: function complete(jqXHR) {
                    $wrapper.append(jqXHR.responseText);
                    var currentCount = $wrapper.find('[data-item]:last').attr('data-count');
                    var totalCount = $wrapper.find('[data-item]:last').attr('data-count-total');
                    if (totalCount === currentCount) $button.hide();
                }
            });
        });

        /**
         * Search by name
         */

        // let $searchByNameForm = $('[data-search]');


        if ((0, _jquery2.default)('.subscribe__actions').children().length) {
            (0, _jquery2.default)('.subscribe').addClass('show-actions');
            (0, _jquery2.default)('html, body').animate({ scrollTop: (0, _jquery2.default)('.subscribe').offset().top }, 500);
        }

        (0, _jquery2.default)('.tenders-content').on('click', '.tender__btn', function () {
            var $self = (0, _jquery2.default)(this);
            var $tender = $self.parent().parent();
            var ACTIVE = 'is-active';

            if ($tender.hasClass(ACTIVE)) {
                $tender.removeClass(ACTIVE);
            } else {
                $tender.addClass(ACTIVE);
            }
        });

        (0, _jquery2.default)('.subscribe__email').on('blur input', function () {
            var $self = (0, _jquery2.default)(this);
            var $validtext = (0, _jquery2.default)('.subscribe__valid');
            var $btn = (0, _jquery2.default)('.subscribe__btn');
            var $container = (0, _jquery2.default)('.subscribe');

            if ($self.val() !== '') {
                var pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
                if (pattern.test($self.val())) {
                    $self.css({ 'border-color': 'green' });
                    $validtext.text('');

                    if ((0, _jquery2.default)('#personal-data').prop('checked')) {
                        $btn.prop('disabled', false);
                    }
                    //   $btn.prop('disabled', false);
                    $btn.on('click', function (e) {
                        e.preventDefault();
                        $container.attr('data-side', '2');
                        $btn.text('Подписаться');
                        $btn.prop('type', 'submit');
                    });
                } else {
                    $btn.prop('disabled', true);
                    $self.css({ 'border-color': 'red' });
                    $validtext.text('Поле e-mail заполнено не верно');
                }
            } else {
                $btn.prop('disabled', true);
                $self.css({ 'border-color': 'red' });
                $validtext.text('Поле e-mail должно быть заполнено');
            }
        });

        (0, _jquery2.default)('.subscribe__btn').on('click', function () {
            var $form = (0, _jquery2.default)('.subscribe__form');
            if ((0, _jquery2.default)(this).prop('type') === 'submit') {
                $form.submit();
            }
        });

        (0, _jquery2.default)('#personal-data').on('change', function () {
            var $elm = (0, _jquery2.default)(this);
            var isChecked = $elm.prop('checked');
            var pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
            var $btn = (0, _jquery2.default)('.subscribe__btn');
            var $email = (0, _jquery2.default)('.subscribe__email');

            if (isChecked) {
                if (pattern.test($email.val())) {
                    $btn.prop('disabled', false);
                }
            } else {
                $btn.prop('disabled', true);
            }
        });
    });
}

!_common.isFirst || tenderOn();

var Tenders = _barba2.default.BaseView.extend({
    namespace: 'tenders',

    onEnter: function onEnter() {
        //console.log('Новый контейнер готов и прикреплен к dom.')
        tenderOn();
    },
    onEnterCompleted: function onEnterCompleted() {
        //console.log('Переход закончился.')
    },
    onLeave: function onLeave() {
        //console.log('Новый переход к новой странице только начался.')
    },
    onLeaveCompleted: function onLeaveCompleted() {
        //console.log('Контейнер был удален из dom.')
    }
});

Tenders.init();

/***/ })

},[79]);
});


// WEBPACK FOOTER //
// js/tenders.js